export const LangIso3 = {
	aar: {
		iso2: "aa",
		name: "Afar",
	},
	abk: {
		iso2: "ab",
		name: "Abkhazian",
	},
	ace: {
		name: "Achinese",
	},
	ach: {
		name: "Acoli",
	},
	ada: {
		name: "Adangme",
	},
	ady: {
		name: ["Adyghe", "Adygei"],
	},
	afa: {
		hierarchy: ["afa"],
		name: "Afro-Asiatic languages",
	},
	afh: {
		name: "Afrihili",
	},
	afr: {
		iso2: "af",
		name: "Afrikaans",
	},
	ain: {
		name: "Ainu",
	},
	aka: {
		iso2: "ak",
		name: "Akan",
	},
	akk: {
		name: "Akkadian",
	},
	alb: {
		iso2: "sq",
		name: "Albanian",
	},
	ale: {
		name: "Aleut",
	},
	alg: {
		hierarchy: ["nai", "aql", "alg"],
		name: "Algonquian languages",
	},
	alt: {
		name: "Southern Altai",
	},
	amh: {
		iso2: "am",
		name: "Amharic",
	},
	ang: {
		name: "English, Old (ca.450-1100)",
	},
	anp: {
		name: "Angika",
	},
	apa: {
		hierarchy: ["nai", "xnd", "ath", "apa"],
		name: "Apache languages",
	},
	ara: {
		iso2: "ar",
		name: "Arabic",
	},
	arc: {
		name: ["Official Aramaic (700-300 BCE)", "Imperial Aramaic (700-300 BCE)"],
	},
	arg: {
		iso2: "an",
		name: "Aragonese",
	},
	arm: {
		iso2: "hy",
		name: "Armenian",
	},
	arn: {
		name: ["Mapudungun", "Mapuche"],
	},
	arp: {
		name: "Arapaho",
	},
	art: {
		hierarchy: ["art"],
		name: "Artificial languages",
	},
	arw: {
		name: "Arawak",
	},
	asm: {
		iso2: "as",
		name: "Assamese",
	},
	ast: {
		name: ["Asturian", "Bable", "Leonese", "Asturleonese"],
	},
	ath: {
		hierarchy: ["nai", "xnd", "ath"],
		name: "Athapascan languages",
	},
	aus: {
		hierarchy: ["aus"],
		name: "Australian languages",
	},
	ava: {
		iso2: "av",
		name: "Avaric",
	},
	ave: {
		iso2: "ae",
		name: "Avestan",
	},
	awa: {
		name: "Awadhi",
	},
	aym: {
		iso2: "ay",
		name: "Aymara",
	},
	aze: {
		iso2: "az",
		name: "Azerbaijani",
	},
	bad: {
		hierarchy: ["nic", "alv", "bad"],
		name: "Banda languages",
	},
	bai: {
		hierarchy: ["nic", "alv", "bai"],
		name: "Bamileke languages",
	},
	bak: {
		iso2: "ba",
		name: "Bashkir",
	},
	bal: {
		name: "Baluchi",
	},
	bam: {
		iso2: "bm",
		name: "Bambara",
	},
	ban: {
		name: "Balinese",
	},
	baq: {
		iso2: "eu",
		name: "Basque",
	},
	bas: {
		name: "Basa",
	},
	bat: {
		hierarchy: ["ine", "bat"],
		name: "Baltic languages",
	},
	bej: {
		name: ["Beja", "Bedawiyet"],
	},
	bel: {
		iso2: "be",
		name: "Belarusian",
	},
	bem: {
		name: "Bemba",
	},
	ben: {
		iso2: "bn",
		name: "Bengali",
	},
	ber: {
		hierarchy: ["afa", "ber"],
		name: "Berber languages",
	},
	bho: {
		name: "Bhojpuri",
	},
	bih: {
		hierarchy: ["ine", "iir", "bih"],
		iso2: "bh",
		name: "Bihari languages",
	},
	bik: {
		name: "Bikol",
	},
	bin: {
		name: ["Bini", "Edo"],
	},
	bis: {
		iso2: "bi",
		name: "Bislama",
	},
	bla: {
		name: "Siksika",
	},
	bnt: {
		hierarchy: ["nic", "alv", "bnt"],
		name: "Bantu languages",
	},
	bos: {
		iso2: "bs",
		name: "Bosnian",
	},
	bra: {
		name: "Braj",
	},
	bre: {
		iso2: "br",
		name: "Breton",
	},
	btk: {
		hierarchy: ["map", "poz", "pqw", "btk"],
		name: "Batak languages",
	},
	bua: {
		name: "Buriat",
	},
	bug: {
		name: "Buginese",
	},
	bul: {
		iso2: "bg",
		name: "Bulgarian",
	},
	bur: {
		iso2: "my",
		name: "Burmese",
	},
	byn: {
		name: ["Blin", "Bilin"],
	},
	cad: {
		name: "Caddo",
	},
	cai: {
		hierarchy: ["cai"],
		name: "Central American Indian languages",
	},
	car: {
		name: "Galibi Carib",
	},
	cat: {
		iso2: "ca",
		name: ["Catalan", "Valencian"],
	},
	cau: {
		hierarchy: ["cau"],
		name: "Caucasian languages",
	},
	ceb: {
		name: "Cebuano",
	},
	cel: {
		hierarchy: ["ine", "cel"],
		name: "Celtic languages",
	},
	cha: {
		iso2: "ch",
		name: "Chamorro",
	},
	chb: {
		name: "Chibcha",
	},
	che: {
		iso2: "ce",
		name: "Chechen",
	},
	chg: {
		name: "Chagatai",
	},
	chi: {
		iso2: "zh",
		name: "Chinese",
	},
	chk: {
		name: "Chuukese",
	},
	chm: {
		name: "Mari",
	},
	chn: {
		name: "Chinook jargon",
	},
	cho: {
		name: "Choctaw",
	},
	chp: {
		name: ["Chipewyan", "Dene Suline"],
	},
	chr: {
		name: "Cherokee",
	},
	chu: {
		iso2: "cu",
		name: [
			"Church Slavic",
			"Old Slavonic",
			"Church Slavonic",
			"Old Bulgarian",
			"Old Church Slavonic",
		],
	},
	chv: {
		iso2: "cv",
		name: "Chuvash",
	},
	chy: {
		name: "Cheyenne",
	},
	cmc: {
		hierarchy: ["map", "poz", "pqw", "cmc"],
		name: "Chamic languages",
	},
	cnr: {
		name: "Montenegrin",
	},
	cop: {
		name: "Coptic",
	},
	cor: {
		iso2: "kw",
		name: "Cornish",
	},
	cos: {
		iso2: "co",
		name: "Corsican",
	},
	cpe: {
		hierarchy: ["crp", "cpe"],
		name: "Creoles and pidgins, English based",
	},
	cpf: {
		hierarchy: ["crp", "cpf"],
		name: "Creoles and pidgins, French-based",
	},
	cpp: {
		hierarchy: ["crp", "cpp"],
		name: "Creoles and pidgins, Portuguese-based",
	},
	cre: {
		iso2: "cr",
		name: "Cree",
	},
	crh: {
		name: ["Crimean Tatar", "Crimean Turkish"],
	},
	crp: {
		hierarchy: ["crp"],
		name: "Creoles and pidgins",
	},
	csb: {
		name: "Kashubian",
	},
	cus: {
		hierarchy: ["afa", "cus"],
		name: "Cushitic languages",
	},
	cze: {
		iso2: "cs",
		name: "Czech",
	},
	dak: {
		name: "Dakota",
	},
	dan: {
		iso2: "da",
		name: "Danish",
	},
	dar: {
		name: "Dargwa",
	},
	day: {
		hierarchy: ["day"],
		name: "Land Dayak languages",
	},
	del: {
		name: "Delaware",
	},
	den: {
		name: "Slave (Athapascan)",
	},
	dgr: {
		name: "Dogrib",
	},
	din: {
		name: "Dinka",
	},
	div: {
		iso2: "dv",
		name: ["Divehi", "Dhivehi", "Maldivian"],
	},
	doi: {
		name: "Dogri",
	},
	dra: {
		hierarchy: ["dra"],
		name: "Dravidian languages",
	},
	dsb: {
		name: "Lower Sorbian",
	},
	dua: {
		name: "Duala",
	},
	dum: {
		name: "Dutch, Middle (ca.1050-1350)",
	},
	dut: {
		iso2: "nl",
		name: ["Dutch", "Flemish"],
	},
	dyu: {
		name: "Dyula",
	},
	dzo: {
		iso2: "dz",
		name: "Dzongkha",
	},
	efi: {
		name: "Efik",
	},
	egy: {
		name: "Egyptian (Ancient)",
	},
	eka: {
		name: "Ekajuk",
	},
	elx: {
		name: "Elamite",
	},
	eng: {
		iso2: "en",
		name: "English",
	},
	enm: {
		name: "English, Middle (1100-1500)",
	},
	epo: {
		iso2: "eo",
		name: "Esperanto",
	},
	est: {
		iso2: "et",
		name: "Estonian",
	},
	ewe: {
		iso2: "ee",
		name: "Ewe",
	},
	ewo: {
		name: "Ewondo",
	},
	fan: {
		name: "Fang",
	},
	fao: {
		iso2: "fo",
		name: "Faroese",
	},
	fat: {
		name: "Fanti",
	},
	fij: {
		iso2: "fj",
		name: "Fijian",
	},
	fil: {
		name: ["Filipino", "Pilipino"],
	},
	fin: {
		iso2: "fi",
		name: "Finnish",
	},
	fiu: {
		hierarchy: ["urj", "fiu"],
		name: "Finno-Ugrian languages",
	},
	fon: {
		name: "Fon",
	},
	fre: {
		iso2: "fr",
		name: "French",
	},
	frm: {
		name: "French, Middle (ca.1400-1600)",
	},
	fro: {
		name: "French, Old (842-ca.1400)",
	},
	frr: {
		name: "Northern Frisian",
	},
	frs: {
		name: "Eastern Frisian",
	},
	fry: {
		iso2: "fy",
		name: "Western Frisian",
	},
	ful: {
		iso2: "ff",
		name: "Fulah",
	},
	fur: {
		name: "Friulian",
	},
	gaa: {
		name: "Ga",
	},
	gay: {
		name: "Gayo",
	},
	gba: {
		name: "Gbaya",
	},
	gem: {
		hierarchy: ["ine", "gem"],
		name: "Germanic languages",
	},
	geo: {
		iso2: "ka",
		name: "Georgian",
	},
	ger: {
		iso2: "de",
		name: "German",
	},
	gez: {
		name: "Geez",
	},
	gil: {
		name: "Gilbertese",
	},
	gla: {
		iso2: "gd",
		name: ["Gaelic", "Scottish Gaelic"],
	},
	gle: {
		iso2: "ga",
		name: "Irish",
	},
	glg: {
		iso2: "gl",
		name: "Galician",
	},
	glv: {
		iso2: "gv",
		name: "Manx",
	},
	gmh: {
		name: "German, Middle High (ca.1050-1500)",
	},
	goh: {
		name: "German, Old High (ca.750-1050)",
	},
	gon: {
		name: "Gondi",
	},
	gor: {
		name: "Gorontalo",
	},
	got: {
		name: "Gothic",
	},
	grb: {
		name: "Grebo",
	},
	grc: {
		name: "Greek, Ancient (to 1453)",
	},
	gre: {
		iso2: "el",
		name: "Greek, Modern (1453-)",
	},
	grn: {
		iso2: "gn",
		name: "Guarani",
	},
	gsw: {
		name: ["Swiss German", "Alemannic", "Alsatian"],
	},
	guj: {
		iso2: "gu",
		name: "Gujarati",
	},
	gwi: {
		name: "Gwich'in",
	},
	hai: {
		name: "Haida",
	},
	hat: {
		iso2: "ht",
		name: ["Haitian", "Haitian Creole"],
	},
	hau: {
		iso2: "ha",
		name: "Hausa",
	},
	haw: {
		name: "Hawaiian",
	},
	heb: {
		iso2: "he",
		name: "Hebrew",
	},
	her: {
		iso2: "hz",
		name: "Herero",
	},
	hil: {
		name: "Hiligaynon",
	},
	him: {
		name: ["Himachali languages", "Western Pahari languages"],
	},
	hin: {
		iso2: "hi",
		name: "Hindi",
	},
	hit: {
		name: "Hittite",
	},
	hmn: {
		name: ["Hmong", "Mong"],
	},
	hmo: {
		iso2: "ho",
		name: "Hiri Motu",
	},
	hrv: {
		iso2: "hr",
		name: "Croatian",
	},
	hsb: {
		name: "Upper Sorbian",
	},
	hun: {
		iso2: "hu",
		name: "Hungarian",
	},
	hup: {
		name: "Hupa",
	},
	iba: {
		name: "Iban",
	},
	ibo: {
		iso2: "ig",
		name: "Igbo",
	},
	ice: {
		iso2: "is",
		name: "Icelandic",
	},
	ido: {
		iso2: "io",
		name: "Ido",
	},
	iii: {
		iso2: "ii",
		name: ["Sichuan Yi", "Nuosu"],
	},
	ijo: {
		hierarchy: ["nic", "alv", "ijo"],
		name: "Ijo languages",
	},
	iku: {
		iso2: "iu",
		name: "Inuktitut",
	},
	ile: {
		iso2: "ie",
		name: ["Interlingue", "Occidental"],
	},
	ilo: {
		name: "Iloko",
	},
	ina: {
		iso2: "ia",
		name: "Interlingua (International Auxiliary Language Association)",
	},
	inc: {
		hierarchy: ["ine", "iir", "inc"],
		name: "Indic languages",
	},
	ind: {
		iso2: "id",
		name: "Indonesian",
	},
	ine: {
		hierarchy: ["ine"],
		name: "Indo-European languages",
	},
	inh: {
		name: "Ingush",
	},
	ipk: {
		iso2: "ik",
		name: "Inupiaq",
	},
	ira: {
		hierarchy: ["ine", "iir", "ira"],
		name: "Iranian languages",
	},
	iro: {
		hierarchy: ["nai", "iro"],
		name: "Iroquoian languages",
	},
	ita: {
		iso2: "it",
		name: "Italian",
	},
	jav: {
		iso2: "jv",
		name: "Javanese",
	},
	jbo: {
		name: "Lojban",
	},
	jpn: {
		iso2: "ja",
		name: "Japanese",
	},
	jpr: {
		name: "Judeo-Persian",
	},
	jrb: {
		name: "Judeo-Arabic",
	},
	kaa: {
		name: "Kara-Kalpak",
	},
	kab: {
		name: "Kabyle",
	},
	kac: {
		name: ["Kachin", "Jingpho"],
	},
	kal: {
		iso2: "kl",
		name: ["Kalaallisut", "Greenlandic"],
	},
	kam: {
		name: "Kamba",
	},
	kan: {
		iso2: "kn",
		name: "Kannada",
	},
	kar: {
		hierarchy: ["sit", "tbq", "kar"],
		name: "Karen languages",
	},
	kas: {
		iso2: "ks",
		name: "Kashmiri",
	},
	kau: {
		iso2: "kr",
		name: "Kanuri",
	},
	kaw: {
		name: "Kawi",
	},
	kaz: {
		iso2: "kk",
		name: "Kazakh",
	},
	kbd: {
		name: "Kabardian",
	},
	kha: {
		name: "Khasi",
	},
	khi: {
		hierarchy: ["khi"],
		name: "Khoisan languages",
	},
	khm: {
		iso2: "km",
		name: "Central Khmer",
	},
	kho: {
		name: ["Khotanese", "Sakan"],
	},
	kik: {
		iso2: "ki",
		name: ["Kikuyu", "Gikuyu"],
	},
	kin: {
		iso2: "rw",
		name: "Kinyarwanda",
	},
	kir: {
		iso2: "ky",
		name: ["Kirghiz", "Kyrgyz"],
	},
	kmb: {
		name: "Kimbundu",
	},
	kok: {
		name: "Konkani",
	},
	kom: {
		iso2: "kv",
		name: "Komi",
	},
	kon: {
		iso2: "kg",
		name: "Kongo",
	},
	kor: {
		iso2: "ko",
		name: "Korean",
	},
	kos: {
		name: "Kosraean",
	},
	kpe: {
		name: "Kpelle",
	},
	krc: {
		name: "Karachay-Balkar",
	},
	krl: {
		name: "Karelian",
	},
	kro: {
		hierarchy: ["nic", "alv", "kro"],
		name: "Kru languages",
	},
	kru: {
		name: "Kurukh",
	},
	kua: {
		iso2: "kj",
		name: ["Kuanyama", "Kwanyama"],
	},
	kum: {
		name: "Kumyk",
	},
	kur: {
		iso2: "ku",
		name: "Kurdish",
	},
	kut: {
		name: "Kutenai",
	},
	lad: {
		name: "Ladino",
	},
	lah: {
		name: "Lahnda",
	},
	lam: {
		name: "Lamba",
	},
	lao: {
		iso2: "lo",
		name: "Lao",
	},
	lat: {
		iso2: "la",
		name: "Latin",
	},
	lav: {
		iso2: "lv",
		name: "Latvian",
	},
	lez: {
		name: "Lezghian",
	},
	lim: {
		iso2: "li",
		name: ["Limburgan", "Limburger", "Limburgish"],
	},
	lin: {
		iso2: "ln",
		name: "Lingala",
	},
	lit: {
		iso2: "lt",
		name: "Lithuanian",
	},
	lol: {
		name: "Mongo",
	},
	loz: {
		name: "Lozi",
	},
	ltz: {
		iso2: "lb",
		name: ["Luxembourgish", "Letzeburgesch"],
	},
	lua: {
		name: "Luba-Lulua",
	},
	lub: {
		iso2: "lu",
		name: "Luba-Katanga",
	},
	lug: {
		iso2: "lg",
		name: "Ganda",
	},
	lui: {
		name: "Luiseno",
	},
	lun: {
		name: "Lunda",
	},
	luo: {
		name: "Luo (Kenya and Tanzania)",
	},
	lus: {
		name: "Lushai",
	},
	mac: {
		iso2: "mk",
		name: "Macedonian",
	},
	mad: {
		name: "Madurese",
	},
	mag: {
		name: "Magahi",
	},
	mah: {
		iso2: "mh",
		name: "Marshallese",
	},
	mai: {
		name: "Maithili",
	},
	mak: {
		name: "Makasar",
	},
	mal: {
		iso2: "ml",
		name: "Malayalam",
	},
	man: {
		name: "Mandingo",
	},
	mao: {
		iso2: "mi",
		name: "Maori",
	},
	map: {
		hierarchy: ["map"],
		name: "Austronesian languages",
	},
	mar: {
		iso2: "mr",
		name: "Marathi",
	},
	mas: {
		name: "Masai",
	},
	may: {
		iso2: "ms",
		name: "Malay",
	},
	mdf: {
		name: "Moksha",
	},
	mdr: {
		name: "Mandar",
	},
	men: {
		name: "Mende",
	},
	mga: {
		name: "Irish, Middle (900-1200)",
	},
	mic: {
		name: ["Mi'kmaq", "Micmac"],
	},
	min: {
		name: "Minangkabau",
	},
	mis: {
		name: "Uncoded languages",
	},
	mkh: {
		hierarchy: ["aav", "mkh"],
		name: "Mon-Khmer languages",
	},
	mlg: {
		iso2: "mg",
		name: "Malagasy",
	},
	mlt: {
		iso2: "mt",
		name: "Maltese",
	},
	mnc: {
		name: "Manchu",
	},
	mni: {
		name: "Manipuri",
	},
	mno: {
		hierarchy: ["map", "poz", "pqw", "phi", "mno"],
		name: "Manobo languages",
	},
	moh: {
		name: "Mohawk",
	},
	mon: {
		iso2: "mn",
		name: "Mongolian",
	},
	mos: {
		name: "Mossi",
	},
	mul: {
		name: "Multiple languages",
	},
	mun: {
		hierarchy: ["aav", "mun"],
		name: "Munda languages",
	},
	mus: {
		name: "Creek",
	},
	mwl: {
		name: "Mirandese",
	},
	mwr: {
		name: "Marwari",
	},
	myn: {
		hierarchy: ["cai", "myn"],
		name: "Mayan languages",
	},
	myv: {
		name: "Erzya",
	},
	nah: {
		hierarchy: ["nai", "azc", "nah"],
		name: "Nahuatl languages",
	},
	nai: {
		hierarchy: ["nai"],
		name: "North American Indian languages",
	},
	nap: {
		name: "Neapolitan",
	},
	nau: {
		iso2: "na",
		name: "Nauru",
	},
	nav: {
		iso2: "nv",
		name: ["Navajo", "Navaho"],
	},
	nbl: {
		iso2: "nr",
		name: ["Ndebele, South", "South Ndebele"],
	},
	nde: {
		iso2: "nd",
		name: ["Ndebele, North", "North Ndebele"],
	},
	ndo: {
		iso2: "ng",
		name: "Ndonga",
	},
	nds: {
		name: ["Low German", "Low Saxon", "German, Low", "Saxon, Low"],
	},
	nep: {
		iso2: "ne",
		name: "Nepali",
	},
	new: {
		name: ["Nepal Bhasa", "Newari"],
	},
	nia: {
		name: "Nias",
	},
	nic: {
		hierarchy: ["nic"],
		name: "Niger-Kordofanian languages",
	},
	niu: {
		name: "Niuean",
	},
	nno: {
		iso2: "nn",
		name: ["Norwegian Nynorsk", "Nynorsk, Norwegian"],
	},
	nob: {
		iso2: "nb",
		name: ["Bokm\\u00e5l, Norwegian", "Norwegian Bokm\\u00e5l"],
	},
	nog: {
		name: "Nogai",
	},
	non: {
		name: "Norse, Old",
	},
	nor: {
		iso2: "no",
		name: "Norwegian",
	},
	nqo: {
		name: "N'Ko",
	},
	nso: {
		name: ["Pedi", "Sepedi", "Northern Sotho"],
	},
	nub: {
		hierarchy: ["ssa", "sdv", "nub"],
		name: "Nubian languages",
	},
	nwc: {
		name: ["Classical Newari", "Old Newari", "Classical Nepal Bhasa"],
	},
	nya: {
		iso2: "ny",
		name: ["Chichewa", "Chewa", "Nyanja"],
	},
	nym: {
		name: "Nyamwezi",
	},
	nyn: {
		name: "Nyankole",
	},
	nyo: {
		name: "Nyoro",
	},
	nzi: {
		name: "Nzima",
	},
	oci: {
		iso2: "oc",
		name: "Occitan (post 1500)",
	},
	oji: {
		iso2: "oj",
		name: "Ojibwa",
	},
	ori: {
		iso2: "or",
		name: "Oriya",
	},
	orm: {
		iso2: "om",
		name: "Oromo",
	},
	osa: {
		name: "Osage",
	},
	oss: {
		iso2: "os",
		name: ["Ossetian", "Ossetic"],
	},
	ota: {
		name: "Turkish, Ottoman (1500-1928)",
	},
	oto: {
		hierarchy: ["cai", "omq", "oto"],
		name: "Otomian languages",
	},
	paa: {
		hierarchy: ["paa"],
		name: "Papuan languages",
	},
	pag: {
		name: "Pangasinan",
	},
	pal: {
		name: "Pahlavi",
	},
	pam: {
		name: ["Pampanga", "Kapampangan"],
	},
	pan: {
		iso2: "pa",
		name: ["Panjabi", "Punjabi"],
	},
	pap: {
		name: "Papiamento",
	},
	pau: {
		name: "Palauan",
	},
	peo: {
		name: "Persian, Old (ca.600-400 B.C.)",
	},
	per: {
		iso2: "fa",
		name: "Persian",
	},
	phi: {
		hierarchy: ["map", "poz", "pqw", "phi"],
		name: "Philippine languages",
	},
	phn: {
		name: "Phoenician",
	},
	pli: {
		iso2: "pi",
		name: "Pali",
	},
	pol: {
		iso2: "pl",
		name: "Polish",
	},
	pon: {
		name: "Pohnpeian",
	},
	por: {
		iso2: "pt",
		name: "Portuguese",
	},
	pra: {
		hierarchy: ["ine", "iir", "inc", "pra"],
		name: "Prakrit languages",
	},
	pro: {
		name: ["Proven\\u00e7al, Old (to 1500)", "Occitan, Old (to 1500)"],
	},
	pus: {
		iso2: "ps",
		name: ["Pushto", "Pashto"],
	},
	"qaa-qtz": {
		name: "Reserved for local use",
	},
	que: {
		iso2: "qu",
		name: "Quechua",
	},
	raj: {
		name: "Rajasthani",
	},
	rap: {
		name: "Rapanui",
	},
	rar: {
		name: ["Rarotongan", "Cook Islands Maori"],
	},
	roa: {
		hierarchy: ["ine", "itc", "roa"],
		name: "Romance languages",
	},
	roh: {
		iso2: "rm",
		name: "Romansh",
	},
	rom: {
		name: "Romany",
	},
	rum: {
		iso2: "ro",
		name: ["Romanian", "Moldavian", "Moldovan"],
	},
	run: {
		iso2: "rn",
		name: "Rundi",
	},
	rup: {
		name: ["Aromanian", "Arumanian", "Macedo-Romanian"],
	},
	rus: {
		iso2: "ru",
		name: "Russian",
	},
	sad: {
		name: "Sandawe",
	},
	sag: {
		iso2: "sg",
		name: "Sango",
	},
	sah: {
		name: "Yakut",
	},
	sai: {
		hierarchy: ["sai"],
		name: "South American Indian languages",
	},
	sal: {
		hierarchy: ["nai", "sal"],
		name: "Salishan languages",
	},
	sam: {
		name: "Samaritan Aramaic",
	},
	san: {
		iso2: "sa",
		name: "Sanskrit",
	},
	sas: {
		name: "Sasak",
	},
	sat: {
		name: "Santali",
	},
	scn: {
		name: "Sicilian",
	},
	sco: {
		name: "Scots",
	},
	sel: {
		name: "Selkup",
	},
	sem: {
		hierarchy: ["afa", "sem"],
		name: "Semitic languages",
	},
	sga: {
		name: "Irish, Old (to 900)",
	},
	sgn: {
		hierarchy: ["sgn"],
		name: "Sign Languages",
	},
	shn: {
		name: "Shan",
	},
	sid: {
		name: "Sidamo",
	},
	sin: {
		iso2: "si",
		name: ["Sinhala", "Sinhalese"],
	},
	sio: {
		hierarchy: ["nai", "sio"],
		name: "Siouan languages",
	},
	sit: {
		hierarchy: ["sit"],
		name: "Sino-Tibetan languages",
	},
	sla: {
		hierarchy: ["ine", "sla"],
		name: "Slavic languages",
	},
	slo: {
		iso2: "sk",
		name: "Slovak",
	},
	slv: {
		iso2: "sl",
		name: "Slovenian",
	},
	sma: {
		name: "Southern Sami",
	},
	sme: {
		iso2: "se",
		name: "Northern Sami",
	},
	smi: {
		hierarchy: ["urj", "fiu", "smi"],
		name: "Sami languages",
	},
	smj: {
		name: "Lule Sami",
	},
	smn: {
		name: "Inari Sami",
	},
	smo: {
		iso2: "sm",
		name: "Samoan",
	},
	sms: {
		name: "Skolt Sami",
	},
	sna: {
		iso2: "sn",
		name: "Shona",
	},
	snd: {
		iso2: "sd",
		name: "Sindhi",
	},
	snk: {
		name: "Soninke",
	},
	sog: {
		name: "Sogdian",
	},
	som: {
		iso2: "so",
		name: "Somali",
	},
	son: {
		hierarchy: ["ssa", "son"],
		name: "Songhai languages",
	},
	sot: {
		iso2: "st",
		name: "Sotho, Southern",
	},
	spa: {
		iso2: "es",
		name: ["Spanish", "Castilian"],
	},
	srd: {
		iso2: "sc",
		name: "Sardinian",
	},
	srn: {
		name: "Sranan Tongo",
	},
	srp: {
		iso2: "sr",
		name: "Serbian",
	},
	srr: {
		name: "Serer",
	},
	ssa: {
		hierarchy: ["ssa"],
		name: "Nilo-Saharan languages",
	},
	ssw: {
		iso2: "ss",
		name: "Swati",
	},
	suk: {
		name: "Sukuma",
	},
	sun: {
		iso2: "su",
		name: "Sundanese",
	},
	sus: {
		name: "Susu",
	},
	sux: {
		name: "Sumerian",
	},
	swa: {
		iso2: "sw",
		name: "Swahili",
	},
	swe: {
		iso2: "sv",
		name: "Swedish",
	},
	syc: {
		name: "Classical Syriac",
	},
	syr: {
		name: "Syriac",
	},
	tah: {
		iso2: "ty",
		name: "Tahitian",
	},
	tai: {
		hierarchy: ["tai"],
		name: "Tai languages",
	},
	tam: {
		iso2: "ta",
		name: "Tamil",
	},
	tat: {
		iso2: "tt",
		name: "Tatar",
	},
	tel: {
		iso2: "te",
		name: "Telugu",
	},
	tem: {
		name: "Timne",
	},
	ter: {
		name: "Tereno",
	},
	tet: {
		name: "Tetum",
	},
	tgk: {
		iso2: "tg",
		name: "Tajik",
	},
	tgl: {
		iso2: "tl",
		name: "Tagalog",
	},
	tha: {
		iso2: "th",
		name: "Thai",
	},
	tib: {
		iso2: "bo",
		name: "Tibetan",
	},
	tig: {
		name: "Tigre",
	},
	tir: {
		iso2: "ti",
		name: "Tigrinya",
	},
	tiv: {
		name: "Tiv",
	},
	tkl: {
		name: "Tokelau",
	},
	tlh: {
		name: ["Klingon", "tlhIngan-Hol"],
	},
	tli: {
		name: "Tlingit",
	},
	tmh: {
		name: "Tamashek",
	},
	tog: {
		name: "Tonga (Nyasa)",
	},
	ton: {
		iso2: "to",
		name: "Tonga (Tonga Islands)",
	},
	tpi: {
		name: "Tok Pisin",
	},
	tsi: {
		name: "Tsimshian",
	},
	tsn: {
		iso2: "tn",
		name: "Tswana",
	},
	tso: {
		iso2: "ts",
		name: "Tsonga",
	},
	tuk: {
		iso2: "tk",
		name: "Turkmen",
	},
	tum: {
		name: "Tumbuka",
	},
	tup: {
		hierarchy: ["sai", "tup"],
		name: "Tupi languages",
	},
	tur: {
		iso2: "tr",
		name: "Turkish",
	},
	tut: {
		hierarchy: ["tut"],
		name: "Altaic languages",
	},
	tvl: {
		name: "Tuvalu",
	},
	twi: {
		iso2: "tw",
		name: "Twi",
	},
	tyv: {
		name: "Tuvinian",
	},
	udm: {
		name: "Udmurt",
	},
	uga: {
		name: "Ugaritic",
	},
	uig: {
		iso2: "ug",
		name: ["Uighur", "Uyghur"],
	},
	ukr: {
		iso2: "uk",
		name: "Ukrainian",
	},
	umb: {
		name: "Umbundu",
	},
	und: {
		name: "Undetermined",
	},
	urd: {
		iso2: "ur",
		name: "Urdu",
	},
	uzb: {
		iso2: "uz",
		name: "Uzbek",
	},
	vai: {
		name: "Vai",
	},
	ven: {
		iso2: "ve",
		name: "Venda",
	},
	vie: {
		iso2: "vi",
		name: "Vietnamese",
	},
	vol: {
		iso2: "vo",
		name: "Volap\\u00fck",
	},
	vot: {
		name: "Votic",
	},
	wak: {
		hierarchy: ["nai", "wak"],
		name: "Wakashan languages",
	},
	wal: {
		name: ["Wolaitta", "Wolaytta"],
	},
	war: {
		name: "Waray",
	},
	was: {
		name: "Washo",
	},
	wel: {
		iso2: "cy",
		name: "Welsh",
	},
	wen: {
		hierarchy: ["ine", "sla", "zlw", "wen"],
		name: "Sorbian languages",
	},
	wln: {
		iso2: "wa",
		name: "Walloon",
	},
	wol: {
		iso2: "wo",
		name: "Wolof",
	},
	xal: {
		name: ["Kalmyk", "Oirat"],
	},
	xho: {
		iso2: "xh",
		name: "Xhosa",
	},
	yao: {
		name: "Yao",
	},
	yap: {
		name: "Yapese",
	},
	yid: {
		iso2: "yi",
		name: "Yiddish",
	},
	yor: {
		iso2: "yo",
		name: "Yoruba",
	},
	ypk: {
		hierarchy: ["esx", "ypk"],
		name: "Yupik languages",
	},
	zap: {
		name: "Zapotec",
	},
	zbl: {
		name: ["Blissymbols", "Blissymbolics", "Bliss"],
	},
	zen: {
		name: "Zenaga",
	},
	zgh: {
		name: "Standard Moroccan Tamazight",
	},
	zha: {
		iso2: "za",
		name: ["Zhuang", "Chuang"],
	},
	znd: {
		hierarchy: ["nic", "alv", "znd"],
		name: "Zande languages",
	},
	zul: {
		iso2: "zu",
		name: "Zulu",
	},
	zun: {
		name: "Zuni",
	},
	zxx: {
		name: ["No linguistic content", "Not applicable"],
	},
	zza: {
		name: ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
	},
};
